import { render, staticRenderFns } from "./review-policy.vue?vue&type=template&id=9c21ef30&scoped=true"
import script from "./review-policy.vue?vue&type=script&lang=js"
export * from "./review-policy.vue?vue&type=script&lang=js"
import style0 from "./review-policy.vue?vue&type=style&index=0&id=9c21ef30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c21ef30",
  null
  
)

export default component.exports